import React, { useMemo, useState } from "react";

export default function AbuseStrikesPanel({ rows = [] }) {
  const [sort, setSort] = useState({ key: "latest", dir: "desc" });

  const sortedRows = useMemo(() => {
    const copy = [...rows];
    copy.sort((a, b) => compareValues(a, b, sort.key, sort.dir));
    return copy;
  }, [rows, sort]);

  return (
    <div>
      <h2 style={styles.title}>Recent abuse strikes by IP</h2>
      <div style={styles.tableWrap}>
        <table style={styles.table}>
          <thead>
            <tr>
              <th style={styles.th}>{sortHeader("IP", "ip", sort, setSort)}</th>
              <th style={styles.th}>{sortHeader("Strike count", "strike_count", sort, setSort)}</th>
              <th style={styles.th}>{sortHeader("Latest", "latest", sort, setSort)}</th>
            </tr>
          </thead>
          <tbody>
            {sortedRows.length ? sortedRows.map((row, idx) => (
              <tr key={`${row.ip || "ip"}-${idx}`}>
                <td style={styles.td}>{row.ip || "-"}</td>
                <td style={styles.td}>{row.strike_count ?? row.count ?? 0}</td>
                <td style={styles.td}>{formatDate(row.latest || row.latest_at || row.created_at)}</td>
              </tr>
            )) : (
              <tr><td style={styles.empty} colSpan={3}>No strike records yet.</td></tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}

function compareValues(a, b, key, dir) {
  const mult = dir === "asc" ? 1 : -1;
  if (key === "ip") return mult * compareIp(a.ip, b.ip);
  if (key === "strike_count") return mult * ((Number(a.strike_count ?? a.count ?? 0)) - (Number(b.strike_count ?? b.count ?? 0)));
  return mult * (toTime(a.latest || a.latest_at || a.created_at) - toTime(b.latest || b.latest_at || b.created_at));
}

function compareIp(a, b) {
  const pa = String(a || "").split(".").map((x) => Number(x) || 0);
  const pb = String(b || "").split(".").map((x) => Number(x) || 0);
  for (let i = 0; i < Math.max(pa.length, pb.length); i += 1) {
    const diff = (pa[i] || 0) - (pb[i] || 0);
    if (diff) return diff;
  }
  return 0;
}

function toTime(value) {
  const d = new Date(value || 0);
  return Number.isNaN(d.getTime()) ? 0 : d.getTime();
}

function formatDate(value) {
  if (!value) return "-";
  const d = new Date(value);
  return Number.isNaN(d.getTime()) ? String(value) : d.toLocaleString();
}

function sortHeader(label, key, sort, setSort) {
  const active = sort.key === key;
  const arrow = active ? (sort.dir === "asc" ? "▲" : "▼") : "↕";
  return (
    <button type="button" onClick={() => setSort((prev) => ({ key, dir: prev.key === key && prev.dir === "asc" ? "desc" : "asc" }))} style={styles.sortBtn}>
      {label} <span style={styles.arrow}>{arrow}</span>
    </button>
  );
}

const styles = {
  title: { margin: "0 0 14px", fontSize: 18, fontWeight: 800 },
  sortBtn: { background: "transparent", border: "none", padding: 0, fontWeight: 800, cursor: "pointer", color: "#111" },
  arrow: { fontSize: 11, marginLeft: 4, color: "#111" },
  tableWrap: { overflowX: "auto" },
  table: { width: "100%", borderCollapse: "collapse" },
  th: { textAlign: "left", padding: "14px 10px", borderBottom: "1px solid #e5e7eb", fontWeight: 800, whiteSpace: "nowrap", color: "#111" },
  td: { padding: "14px 10px", borderBottom: "1px solid #f0f0f0", verticalAlign: "top" },
  empty: { padding: 20, textAlign: "center", color: "#667085" },
};
